import "@mantine/charts/styles.css"
import "@mantine/core/styles.css"
import "@mantine/dates/styles.css"
import "@mantine/notifications/styles.css"
import "@medplum/react/styles.css"
import { IconHome } from "@tabler/icons-react"
import React from "react"
import "./App.css"
import { AppShell } from "./components/appshell/AppShell"
import { Dashboard } from "./components/dashboard/Dashboard"
import TelmedaLogo from "./components/ui/TelmedaLogo"

export function App({ children }): JSX.Element | null {
    return (
        <AppShell
            logo={<TelmedaLogo width={43} />}
            resourceTypeSearchDisabled
            pathname={location.pathname}
            menus={[
                {
                    links: [
                        { icon: <IconHome />, label: "Dashboard", href: "/" },
                    ],
                },
            ]}
        >
            {location.pathname === "/" && <Dashboard />}
            {children}
        </AppShell>
    )
}
